import { createConfirmation } from "react-confirm";
import RosterAddModal from "./RosterAddModal";

export const showRosterAddModal = createConfirmation(RosterAddModal);
